module.exports = __webpack_public_path__ + "img/arrow_down_2.a75ea26b.svg";